import React from 'react';
import YouTube from 'react-youtube';


class YoutubeClass extends React.Component {



  render() {
    const { videoId } = this.props;
    const opts = {
      playerVars: {
        autoplay: 1,
        controls: 1, // Mantieni i controlli
        modestbranding: 1, // Riduce il branding di YouTube
        showinfo: 0
      },
};



    return <YouTube videoId={videoId} opts={opts} iframeClassName="youtube-iframe"/>;
  }


}
  export default YoutubeClass;